import { graphql } from "react-relay";

export const DELETE_CONDITION_MUTATION = graphql`
	mutation deleteConditionButton_DeleteConditionMutation($input: DeleteConditionInput!) {
		Admin {
			Billing {
				deleteCondition(input: $input) {
					limitedCartDiscount {
						...limitedCartDiscountForm_LimitedCartDiscountFragment
					}
				}
			}
		}
	}
`;
